var exports = {
  "o4": "instructionContainer__ktBLyi",
  "xP": "instruction__WVRb3y",
  "xQ": "footerContainer__YkrNHi",
  "Ql": "footerForm__utAxYj",
  "wC": "footerButton__QQic4Z",
};

module.exports = exports;
